import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, as: Tag = "h1", className = "", baseDelay = 0.15 }) => (
    <Tag className={className}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                <motion.span
                    className="block will-change-transform"
                    initial={{ y: "112%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.95, delay: baseDelay + i * 0.13, ease: EASE }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </Tag>
);

export const Overline = ({ children, light = false }) => (
    <p
        className={`font-display text-xs font-bold uppercase tracking-[0.24em] ${light ? "text-amber" : "text-steel"}`}
        data-testid="section-overline"
    >
        {children}
    </p>
);
